import { type StatusLevel } from '../../Moonstar/StatusBadge';

export type KpiPerformanceLevel = Extract<
  StatusLevel,
  'success' | 'warning' | 'danger'
>;

/** >= 89.5%: success (green), >= 84.5%: warning (orange), else danger (red) */
export const getKpiPerformanceLevel = (value: number): KpiPerformanceLevel =>
  // The reason for the 0.5. is to make sure that values are rounded correctly when displayed as percentages
  value >= 0.895 ? 'success' : value >= 0.845 ? 'warning' : 'danger';

/** Formats a performance ratio as a whole percentage (e.g. `0.9` → `90%`) */
export const formatKpiPerformance = new Intl.NumberFormat(undefined, {
  style: 'percent',
  maximumFractionDigits: 0,
}).format;
